import { Box, Step, StepLabel, Stepper } from '@mui/material';
import { useEffect, useState, } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from "react-router-dom";
import { setBackHandler, setHeaderTitle } from '../../helpers/header.helper';
import * as selector from "../../selectors/selectors";
import { UserService } from '../../services/UserService';
import ManualPayment from "../payment/manualPayment.component";
import { AppRoutes } from '../routes/route.path';
import NewSelectPlan from '../new-PhoneNumbers/NewSelectPlan';
import NewSelectAddon from '../new-PhoneNumbers/NewSelectAddon';
import NewPayment from '../new-PhoneNumbers/newPayment';
import NewPaymentStatus from '../new-PhoneNumbers/NewPaymentStatus';
import { OrganizationService } from '../../services/OrganizationService';
import { MapToOrgPlanHistory } from '../../models/organization.model';

const NewRecharge = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice);
    const IsTeamsApp: boolean = useSelector(selector.isTeamsApp)
    const [activeStep, setActiveStep] = useState(0);
    const [stepdata, setStepdata] = useState<any>()
    const IsManualPayment = false // state.ManualPayment

    const setBack = (index, label) => {
        if (index < activeStep) {
            label === "Payment" ? setActiveStep(0) : setActiveStep(index)
        }
    }

    const handleNext = (data?: any) => {
        setStepdata({ ...stepdata, ...data })
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }

    const getRechargeSteps = (IsMobileDevice: boolean, IsTeamsApp: boolean, IsAddonRecharge: boolean, IsManualPayment?: boolean) => IsAddonRecharge ? [
        {
            label: "Select Add-on",
            component: <NewSelectAddon HandleNext={handleNext} Stepdata={stepdata} />
        },
        {
            label: "Payment",
            component: IsManualPayment ? <ManualPayment HandleNext={handleNext} Stepdata={stepdata} /> : <NewPayment HandleNext={handleNext} IsMobileDevice={IsMobileDevice} Stepdata={stepdata} />
        },
        {
            label: "Payment Status",
            component: <NewPaymentStatus IsTeamsApp={IsTeamsApp} Stepdata={stepdata} />
        },
    ] : [
        {
            label: "Select Plan",
            component: <NewSelectPlan onSelectPlan={handleNext} Stepdata={stepdata} />
        },
        {
            label: "Payment",
            component: IsManualPayment ? <ManualPayment HandleNext={handleNext} Stepdata={stepdata} /> : <NewPayment HandleNext={handleNext} IsMobileDevice={IsMobileDevice} Stepdata={stepdata} />
        },
        {
            label: "Payment Status",
            component: <NewPaymentStatus IsTeamsApp={IsTeamsApp} Stepdata={stepdata} />
        },
    ];

    useEffect(() => {
        setHeaderTitle("Recharge")
        setBackHandler(() => navigate(UserService.hasSysAdminRole() ? AppRoutes.NEW_ORGANIZATION : AppRoutes.ACCOUNT_BILLING))
    }, [])

    useEffect(() => {
        OrganizationService.GetNewOrganizationRechargeHistory(state.OrganizationId).then((res) => {
            let data = { planHistory: !!res.data ? res.data.map(MapToOrgPlanHistory) : [] }
            setStepdata({ ...stepdata, ...data })
        })
    }, [])

    const steps = getRechargeSteps(IsMobileDevice, IsTeamsApp, state.IsAddonRecharge, IsManualPayment);
    const Steps = UserService.hasSysAdminRole() ? steps.slice(0, steps.length - 1) : IsManualPayment ? steps.slice(0, steps.length - 1) : steps
    return (
        <>
            <Box className='d-flex flex-direction align-center '>
                <Stepper activeStep={activeStep} className={'w-80 mb-1 c-pointer'} sx={{
                    "& .MuiStepIcon-root.Mui-completed": {
                        color: "success.main"
                    },
                    "& .MuiStepConnector-line": {
                        borderTopWidth: 4,
                        borderRadius: 10,
                        borderTopColor: "#d3d3d3"
                    },
                    // active line
                    "& .MuiStepConnector-root.Mui-active .MuiStepConnector-line": {
                        borderTopColor: "var(--color-primary-success)"
                    }
                }} >
                    {Steps.map((step, index) => (
                        <Step key={index} onClick={() => setBack(index, step.label)} >
                            <StepLabel className={'h3-regular'} StepIconProps={{
                                sx: {
                                    "&.Mui-completed": {
                                        color: "green"
                                    }
                                }
                            }}
                            >{step.label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>
            </Box>
            <div className='d-flex '>
                {steps[activeStep].component}
            </div>
        </>
    )
}
export default NewRecharge;